import { getToken} from '@/utils/cookieUtil'

let server = process.env.VUE_APP_SOCKET_PROTOCOL + process.env.VUE_APP_DOMAIN;
let ws_url = server + "ws/server"
export let socket = null;
export let wsHeartbeat = false;
export function doSocket() {
    let token = getToken();
    socket = new WebSocket(ws_url,[token]);
    // 连接打开事件处理程序
   
    // 连接关闭事件处理程序
    socket.onclose = function (event) {
        wsHeartbeat = false
        console.log("连接已关闭");
    };

    // 连接错误事件处理程序
    socket.onerror = function (error) {
      wsHeartbeat = false
      console.log("连接出现错误：" + error.message);
    };
}

export function getWsHeartbeat(){
   return wsHeartbeat 
}
export function setWsHeartbeat(val){
  wsHeartbeat = val
}